import Skeleton from '@zenbusiness/zui/Skeleton';

import useBreakpoints from '#client/hooks/useBreakpoints';

const ChartSkeleton = () => {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <Skeleton
      aria-label="Skeleton for balance chart"
      height={isDesktop ? 240 : 200}
    />
  );
};

export default ChartSkeleton;
